// ── איפה העובד היה כשיצא בלי חלק (אלי 04/11/2026) ───────────────────────────
//
// העמדה זוכרת את השלב האחרון שהמסך היה בו (רשימה / חיפוש / בחירה / שרטוט),
// ושולחת אותו עם הזיהוי הבא — השרת כותב אותו על הכניסה הקודמת באותה עמדה.
// משתנה בזיכרון בלבד: בלי בקשה, בלי אחסון, בלי השפעה על המסך.

let last: string | null = null;

export function noteStationStep(step: string): void { last = step; }

/** מה שהזיהוי שולח: המסך שבו הוא קורה, והשלב שהקודם השאיר (פעם אחת). */
export function identifyTrail(): { screen?: string; prevStep?: string } {
  const prevStep = last;
  last = null;
  const screen = typeof window !== 'undefined' ? window.location.pathname : undefined;
  return { ...(screen ? { screen } : {}), ...(prevStep ? { prevStep } : {}) };
}
